import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef} from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer
} from '../template/FormulaFormTemplates';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { RectangularVM } from './RectangularVM';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';


const  RectangularComponent = (props) => {
    const vm = useRef(new RectangularVM(props)).current;
    useEffect(() => {
      // on initial render, load form data - desc, img, help link
      vm.getFormData(`${props.section}_${props.title}_${props.id}`);
    }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />    
      <div className="formula-content row ">
        <InputContainer computeCallback={() => {vm.computeRectangular() }} printCallback={() => vm.launchAndExport()} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults}>
        <h2 className='sections-heading'>Specify</h2>
            <RadioGroup
              labelId="rectangular-radio"
              items={[
                {
                  id: "sideControl",
                  name: "sideControl",
                  label:"Side a and b",
                  className: 'usa-radio__input--tile',
                  checked: vm.sideControl,
                  onChange: vm.handleFormChange,
                },
                {
                  id: 'diagonalControl',
                  name: 'diagonalControl',
                  label: 'Side and Diagonal',
                  className: 'usa-radio__input--tile',
                  checked: vm.diagonalControl,
                  onChange: vm.handleFormChange,
                },
              ]}
            />
            <h2 className='sections-heading'>General</h2>   
            {vm.rectangularControl === 1 ?
          <>    
            <Input
              label="Side 'a'"
              idAndName="sideA"
              valid={!vm.formValidation.sideA}
              value={vm.rectangularForm.sideA}
              className={vm.rectangularErrorClass('sideA')}
              type="number"
              step={'0.01'}
              onChange={(e) => { vm.handleFormChange(e) }}
              onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
              onKeyDown={vm.handleOnKeyDown}
              min={0.01}
            />
            <Input 
              label="Side 'b'" 
              idAndName="sideB" 
              valid={!vm.formValidation.sideB}
              value={vm.rectangularForm.sideB}
              className={vm.rectangularErrorClass('sideB')}
              type="number" 
              step={'0.01'}
              min={0.01}
              onChange={vm.handleFormChange}
              onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
              onKeyDown={vm.handleOnKeyDown}
            />
            <Input 
              label="Diagonal" 
              idAndName="diagonal" 
              valid={true}
              value={vm.rectangularForm?.diagonal? vm.rectangularForm?.diagonal :0}
              className="calculated-result-box"
              type="string" 
              onChange={()=>{}} 
              readOnly={true}            
            />
         </>
        :
        <> 
            <Input
              label="Side 'a'"
              idAndName="sideA"
              valid={!vm.formValidation.sideA}
              value={vm.rectangularForm.sideA}
              className={vm.rectangularErrorClass('sideA')}
              type="number"
              step={'0.01'}
              onChange={(e) => { vm.handleFormChange(e) }}
              onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
              onKeyDown={vm.handleOnKeyDown}
              min={0.01}
            />
            <Input 
              label="Diagonal" 
              idAndName="diagonal" 
              valid={!vm.formValidation.diagonal}
              value={vm.rectangularForm.diagonal}
              className={vm.rectangularErrorClass('diagonal')}
              type="number" 
              step={'0.01'}
              min={0.01}
              onChange={vm.handleFormChange}
              onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
              onKeyDown={vm.handleOnKeyDown}
            />
            <Input 
              label="Side 'b'" 
              idAndName="sideB" 
              valid={true}
              value={vm.rectangularForm?.sideB? vm.rectangularForm?.sideB : 0}
              className="calculated-result-box"
              type="string" 
              onChange={()=>{}} 
              readOnly={true}           
            />
         </>
        }

         </InputContainer >           
       <div className="col formula-information " >
              {vm.hasResults ? (
              <div className="row formula-results ">
                  <ResultsContainer>
                    <div className="col-auto result-value-group">
                      <div className="row">
                        <div className="col-auto result-label">Area (sq units):</div>
                        <div className="col-auto result-value">{vm.rectangularResults.area}</div>
                      </div>
                    </div>
                  </ResultsContainer> 
                  </div>
             ) : ''}    
          <div className="row formula-description">
            <DescriptionContainer>
              <p> 
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>       
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
          
            <ImageContainer>
              <img
                className=""
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
       </div>
       {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer 
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const RectangularFormula = observer(RectangularComponent);